import { Link } from "react-router-dom-v5-compat";
import { useModuleBEM } from "@b2bportal/core-themes";
import { TRIPS_PATH } from "@b2bportal/core-utilities";
import { useI18nContext } from "@hopper-b2b/i18n";
import clsx from "clsx";
import { RefundBreakdown, type RefundBreakdownData } from "../RefundBreakdown";
import styles from "./CancellationSuccess.module.scss";
import { FlightInsuranceCancellationBanner } from "@/components";

const ComponentName = "CancellationSuccess";

export const CancellationSuccess = ({
  bookingEmail,
  className,
  breakdown,
  hasInsurance = false,
}: {
  bookingEmail: string | undefined;
  className?: string;
  breakdown?: RefundBreakdownData | null;
  hasInsurance?: boolean;
}) => {
  const { t } = useI18nContext();
  const [block, cn] = useModuleBEM(styles, ComponentName);

  return (
    <div className={clsx(block, className)}>
      <div className={cn("success-header")}>
        <h2 className={cn("title")}>{t("selfServe.cancelationComplete")}</h2>
      </div>
      <p className={cn("deadline")}>
        {t("selfServe.cancelSuccessSubtitle", {
          email: bookingEmail ?? "",
        })}
      </p>

      {breakdown != null && <RefundBreakdown breakdown={breakdown} />}

      <Link className={cn("back-link")} to={TRIPS_PATH}>
        {t("selfServe.backToTrips")}
      </Link>

      {hasInsurance && <FlightInsuranceCancellationBanner />}
    </div>
  );
};
